import { useState, useEffect } from "react";

import Swal from "sweetalert2";

import { db } from "../../../util/firebase";
import {
  query,
  collection,
  getDocs,
  where,
  doc,
  updateDoc,
  deleteDoc,
} from "firebase/firestore";

import { DatePicker } from "reactstrap-date-picker";

import { useNavigate, useParams } from "react-router-dom";

import BarLoader from "react-spinners/BarLoader";

import { FaChevronLeft } from "react-icons/fa";

import { Button } from "reactstrap";

function AdminUserPage() {
  // eslint-disable-next-line
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  const params = useParams();
  const userUid = params.userUid;

  const [userObject, setUserObject] = useState();
  const [username, setUsername] = useState();
  const [email, setEmail] = useState();
  const [dateCreated, setDateCreated] = useState();
  const [firstName, setFirstName] = useState();
  const [lastName, setLastName] = useState();
  const [phoneNumber, setPhoneNumber] = useState();
  const [country, setCountry] = useState();
  const [dateOfBirth, setDateOfBirth] = useState();
  const [gender, setGender] = useState();
  const [tickets, setTickets] = useState();

  const fetchUser = async () => {
    try {
      setIsLoading(true);

      const q = query(collection(db, "users"), where("uid", "==", userUid));
      const doc = await getDocs(q);
      // eslint-disable-next-line
      const data = doc.docs[0]?.data();

      setUserObject(data);
      setUsername(data.username);
      setDateCreated(data.dateCreated);
      setEmail(data.email);
      setFirstName(data.firstName);
      setLastName(data.lastName);
      setPhoneNumber(data.phoneNumber);
      setCountry(data.country);
      setDateOfBirth(data.dateOfBirth);
      setGender(data.gender);
      setTickets(data.tickets);

      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching user data");
    }
  };

  const formatDateDisplay = (dateTime) => {
    try {
      if (!dateTime) return "";
      let d = null;
      if (
        typeof dateTime === "object" &&
        dateTime !== null &&
        typeof dateTime.toDate === "function"
      ) {
        d = dateTime.toDate();
      } else if (
        typeof dateTime === "object" &&
        dateTime !== null &&
        typeof dateTime.seconds === "number"
      ) {
        d = new Date(dateTime.seconds * 1000);
      } else {
        d = new Date(dateTime);
      }
      if (!d || isNaN(d.getTime())) return "";
      const dd = String(d.getDate()).padStart(2, "0");
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const yyyy = d.getFullYear();
      return `${dd}.${mm}.${yyyy}`;
    } catch (e) {
      return "";
    }
  };

  useEffect(() => {
    if (userUid) {
      fetchUser();
    }
    // eslint-disable-next-line
  }, [userUid]);

  const saveChanges = () => {
    Swal.fire({
      text: "Are you sure you want to save your changes to this user?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#005EE1",
      confirmButtonText: "YES, SAVE",
      cancelButtonText: "NO, CANCEL",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setIsLoading(true);

        try {
          const userRef = query(
            collection(db, "users"),
            where("uid", "==", userUid)
          );
          const findUsers = await getDocs(userRef);
          findUsers.forEach(async (userObject) => {
            const getUser = doc(db, "users", userObject.id);
            await updateDoc(getUser, {
              username: username,
              email: email,
              firstName: firstName,
              lastName: lastName,
              phoneNumber: phoneNumber,
              country: country,
              dateOfBirth: dateOfBirth,
              gender: gender,
              tickets: parseFloat(tickets),
            }).then(() => {
              fetchUser();
            });
          });

          setIsLoading(false);
        } catch (err) {
          console.error(err);
          setIsLoading(false);
        }
      }
    });
  };

  const deleteArticle = async () => {
    Swal.fire({
      text: "Are you sure you want to delete this user?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#005EE1",
      confirmButtonText: "YES, DELETE",
      cancelButtonText: "NO, CANCEL",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setIsLoading(true);

          const userRef = query(
            collection(db, "users"),
            where("uid", "==", userUid)
          );
          const findUsers = await getDocs(userRef);
          findUsers.forEach(async (userObject) => {
            const getUsers = doc(db, "users", userObject.id);
            await deleteDoc(getUsers);
          });

          Swal.fire({
            text: "User deleted successfully",
            icon: "success",
            confirmButtonColor: "#005EE1",
            confirmButtonText: "OKAY",
          });

          navigate(-1);

          setIsLoading(false);
        } catch (err) {
          console.error(err);
          alert("An error occured while deleting user");
        }
      }
    });
  };

  // const testFunction = async () => {
  //   console.log('Test function');

  //   let userTickets= tickets;
  //   let ticketsToAward= 3;
  //   let userStarCoins= 100;
  //   let userChampionPoints= 100;

  //   let doesUserHaveAnActiveTicketBoost;
  //   console.log(userObject.ticketBoostExpirationDatetime)
  // 	if (userObject.ticketBoostExpirationDatetime){
  //     console.log(userObject.ticketBoostExpirationDatetime.toDate())
  //     console.log(new Date())
  // 	  if (userObject.ticketBoostExpirationDatetime.toDate() > new Date()){
  //       console.log('User has an active ticket boost');
  // 			doesUserHaveAnActiveTicketBoost = true;
  // 		} else {
  // 			doesUserHaveAnActiveTicketBoost = false;
  //       console.log('User does not have an active ticket boost');
  // 		}
  //   } else {
  // 		doesUserHaveAnActiveTicketBoost = false;
  //     console.log('User does not have an active ticket boost 2');
  // 	}

  // 	userTickets += (ticketsToAward * (doesUserHaveAnActiveTicketBoost ? 2 : 1));
  // 	userChampionPoints += ticketsToAward;

  //   console.log({
  //     tickets: parseFloat(userTickets),
  // 	  starCoins: parseFloat(userStarCoins),
  // 	  championPoints: parseFloat(userChampionPoints),
  // 	  ticketBoostExpirationDatetime: doesUserHaveAnActiveTicketBoost ? userObject.ticketBoostExpirationDatetime : null
  //   });
  // }

  if (isLoading)
    return (
      <div className="loadingPage">
        <img
          alt="logo"
          src="https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Flogos%2F01%20-%20SL%20Logo%203.png?alt=media&token=2e5a6320-d2d7-45f8-9bc9-a8f9c7f8caa6"
          style={{
            width: 100,
            marginBottom: "1rem",
          }}
        />
        <BarLoader color="#005EE1" />
      </div>
    );

  return (
    <div id="newsArticlePage" className="page">
      <h1>
        <FaChevronLeft
          onClick={() => navigate(-1)}
          style={{
            color: "#005EE1",
            width: 35,
            height: 35,
            marginTop: -8,
            marginRight: "0.25rem",
            cursor: "pointer",
          }}
        />
        USER
      </h1>
      <div>
        {/* <Button onClick={testFunction} className='primaryBtn' style={{marginBottom: '0.5rem'}}>
          TEST
        </Button> */}
        <p className="inputLabel" style={{ textAlign: "left" }}>
          Username
        </p>
        <input
          type="text"
          className="mainInput"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          placeholder="The user's username"
          style={{ marginBottom: "0.5rem" }}
        />
        <p className="inputLabel" style={{ textAlign: "left" }}>
          Email
        </p>
        <input
          type="text"
          className="mainInput"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="The user's email"
          style={{ marginBottom: "0.5rem" }}
          disabled
        />
        <p className="inputLabel" style={{ textAlign: "left" }}>
          Date created
        </p>
        <input
          type="text"
          className="mainInput"
          value={formatDateDisplay(dateCreated)}
          placeholder="User creation date"
          style={{ marginBottom: "0.5rem" }}
          disabled
        />
        <p className="inputLabel" style={{ textAlign: "left" }}>
          First name
        </p>
        <input
          type="text"
          className="mainInput"
          value={firstName}
          onChange={(e) => setFirstName(e.target.value)}
          placeholder="The user's first name"
          style={{ marginBottom: "0.5rem" }}
        />
        <p className="inputLabel" style={{ textAlign: "left" }}>
          Last name
        </p>
        <input
          type="text"
          className="mainInput"
          value={lastName}
          onChange={(e) => setLastName(e.target.value)}
          placeholder="The user's last name"
          style={{ marginBottom: "0.5rem" }}
        />
        <p className="inputLabel" style={{ textAlign: "left" }}>
          Phone number
        </p>
        <input
          type="text"
          className="mainInput"
          value={phoneNumber}
          onChange={(e) => setPhoneNumber(e.target.value)}
          placeholder="The user's phone number"
          style={{ marginBottom: "0.5rem" }}
        />
        <p className="inputLabel" style={{ textAlign: "left" }}>
          Country
        </p>
        <input
          type="text"
          className="mainInput"
          value={country}
          onChange={(e) => setCountry(e.target.value)}
          placeholder="The user's country"
          style={{ marginBottom: "0.5rem" }}
        />
        <p className="inputLabel" style={{ textAlign: "left" }}>
          Date of birth
        </p>
        {/* <input
          type='text'
          className="mainInput"
          value={dateOfBirth}
          onChange={(e) => setDateOfBirth(e.target.value)}
          placeholder="The user's date of birth"
          style={{marginBottom: '0.5rem'}}
        /> */}
        <DatePicker
          id="admin-user-birthdate-date-datepicker"
          className="mainInput"
          showClearButton={false}
          value={dateOfBirth}
          onChange={(v) => setDateOfBirth(v)}
          dateFormat="DD.MM.YYYY"
          placeholder="The user's date of birth (DD.MM.YYYY)"
          style={{ marginBottom: "0.5rem", borderRadius: 20 }}
        />
        <p className="inputLabel" style={{ textAlign: "left" }}>
          Gender
        </p>
        <input
          type="text"
          className="mainInput"
          value={gender}
          onChange={(e) => setGender(e.target.value)}
          placeholder="The user's gender"
          style={{ marginBottom: "0.5rem" }}
        />
        <p className="inputLabel" style={{ textAlign: "left" }}>
          Tickets
        </p>
        <input
          type="number"
          className="mainInput"
          value={tickets}
          onChange={(e) => setTickets(e.target.value)}
          placeholder="The user's tickets"
          style={{ marginBottom: "0.5rem" }}
        />
        <Button
          onClick={saveChanges}
          className="primaryBtn"
          style={{ marginTop: "0.5rem" }}
          disabled={
            username === userObject?.username &&
            firstName === userObject?.firstName &&
            lastName === userObject?.lastName &&
            phoneNumber === userObject?.phoneNumber &&
            country === userObject?.country &&
            dateOfBirth === userObject?.dateOfBirth &&
            gender === userObject?.gender &&
            parseFloat(tickets) === userObject?.tickets
          }
        >
          SAVE
        </Button>
        <Button
          onClick={deleteArticle}
          className="secondaryBtn"
          style={{ marginTop: "0.5rem", boxShadow: "none" }}
        >
          DELETE
        </Button>
      </div>
    </div>
  );
}

export default AdminUserPage;
